<template>
  <img :src="imageUrl" class="img-fluid d-block" :alt="event.header" v-if="imageUrl">
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  export default {
    name: "event-image",
    props: {
      event: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        imageUrl: null
      }
    },
    async mounted() {
      let storageRef = await firebase.storage()
      let imageRef = await storageRef.ref(`images/${this.event.image}`)
      this.imageUrl = await imageRef.getDownloadURL()
    }
  }
</script>